<div class="overflow-x-auto rounded-lg border border-base-content/20">
  <table class="table table-zebra static">
    <thead class="text-base font-medium">
      <tr>
        @if (invoices.length > 0 && invoices[0].completed) {
          <td>Completed At</td>
        }
        <td>Total Amount</td>
        <td>Transaction Month</td>
        <td>Job Count</td>
        <td
          class="cursor-pointer"
          (click)="sortChanged.emit('created_at')"
        >
          <span>Created Date</span>
          @if (currentSort?.field === 'created_at') {
            @if (currentSort?.direction === 'ASC') {
              <app-chevron-up-icon
                class="absolute inline-block h-6 w-6"
              ></app-chevron-up-icon>
            } @else {
              <app-chevron-down-icon
                class="absolute inline-block h-6 w-6"
              ></app-chevron-down-icon>
            }
          }
        </td>
        @if (showDeleteButton) {
          <td class="w-10"></td>
        }
        @if (showStatusButton) {
          <td>Status</td>
          <td></td>
        }
      </tr>
    </thead>
    <tbody>
      @for (invoice of invoices; track invoice) {
        <tr
          class="cursor-pointer"
          (click)="
            browseToInvoice(
              invoice.id,
              invoice.tenant_id
            )
          "
        >
          @if (invoice.completed) {
            <td>
              {{
                invoice.completed_at
                  | date: 'MM/dd/yyyy, hh:mmaa'
              }}
            </td>
          }
          <td>
            {{ invoice.total_amount | currency }}
          </td>
          <td>
            {{ getDisplayTransactionMonth(invoice.transaction_yyyymm) | date: 'MM/YYYY' }}
          </td>
          <td>
            {{ invoice.job_count }}
          </td>
          <td>
            {{
              invoice.created_at | date: 'MM/dd/yyyy, hh:mmaa'
            }}
          </td>
          @if (showDeleteButton) {
            <td class="w-10">
              <div
                class="h-6 w-6 text-error hover:text-error/80"
                (click)="deleteInvoice($event, invoice)"
              >
                <app-trash-icon></app-trash-icon>
              </div>
            </td>
          }
          @if (showStatusButton) {
            <td>
              {{ (invoice.status || 'completed') | titlecase }}
            </td>
            <td class="w-24">
              <div
                class="h-6 w-6 cursor-pointer hover:text-base-content/80"
                (click)="changeStatus($event, invoice)"
              >
                <app-edit-icon></app-edit-icon>
              </div>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
